window.addEventListener('load', () => {
  const modelSelect = document.querySelector("#section-filter-model");
  const makeSelect = document.querySelector("#section-filter-make");
  const yearSelect = document.querySelector("#section-filter-year");

  modelSelect.value = ""
  makeSelect.value = ""
  yearSelect.value = ""
})

document.querySelector("#section-filter-make").addEventListener('change', (e) => {
  const modelSelect = document.querySelector("#section-filter-model");
  const yearSelect = document.querySelector("#section-filter-year");

  for (let span of modelSelect.querySelectorAll("span").entries()) {
    span[1].replaceWith(span[1].children[0])
  }

  for (let entry of modelSelect.querySelectorAll("option").entries()) {
    if (entry[1].getAttribute("data-make") !== e.target.value && !entry[1].disabled) {
      const wrapper = document.createElement("span");
      entry[1].parentElement.insertBefore(wrapper, entry[1])
      wrapper.appendChild(entry[1])
    }
  }

  modelSelect.value = ""
  modelSelect.disabled = false;

  yearSelect.value = ""
  yearSelect.disabled = true;

  const submitButton = document.querySelector("#section-filters-submit");
  submitButton.disabled = true
})

document.querySelector("#section-filter-model").addEventListener('change', (e) => {
  const yearSelect = document.querySelector("#section-filter-year");
  yearSelect.disabled = false;
  yearSelect.value = ""
  
  const submitButton = document.querySelector("#section-filters-submit");
  submitButton.disabled = true
})

document.querySelector("#section-filter-year").addEventListener('change', (e) => {
  const submitButton = document.querySelector("#section-filters-submit");
  submitButton.disabled = false

})

document.querySelector("#section-filters-submit").addEventListener('click', (e) => {
  const makeSelect = document.querySelector("#section-filter-make");
  const modelSelect = document.querySelector("#section-filter-model");
  const yearSelect = document.querySelector("#section-filter-year");
  
  const collectionUrl = '/collections/all/';
  const url = new URL(collectionUrl, window.shopUrl);

  makeSelect.value.split('+').forEach(filter => {
    url.searchParams.append('filter.p.m.filter.make', filter);
  });

  modelSelect.value.split('+').forEach(filter => {
    url.searchParams.append('filter.p.m.filter.model', filter);
  });

  url.searchParams.append('filter.p.m.filter.yearf', yearSelect.value);


  this.window.location.href = url
})